import React, { useState } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; // eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";
import WordSpacedText from "../WordSpacedText.js";

const PageWrapper = styled.div`
  ${tw`max-w-4xl mx-auto py-8`}
  direction: rtl;
  text-align: right;
  font-family: "CustomFont", serif;
`;

const Subheading = tw(
  SubheadingBase
)`mb-4 text-center md:text-right text-4xl [font-family: "CustomFont"]`; // matching carousel subheading size
const Heading = tw(
  SectionHeading
)`w-full text-right text-5xl [font-family: "CustomFont"]`; // bigger heading like carousel
const Description = tw(
  SectionDescription
)`w-full text-right text-2xl leading-relaxed [font-family: "CustomFont"]`; // larger for readability

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`mt-12 max-w-4xl relative`;
const FAQ = tw.div`
  cursor-pointer select-none mt-0 px-8 sm:px-10 py-6 sm:py-5 
  rounded-lg text-gray-800 hover:text-gray-900 
  bg-gray-200 hover:bg-gray-300 transition duration-300 
  text-2xl text-right
`;

const Question = tw.div`
  flex justify-between items-center cursor-pointer p-4 
  bg-white text-black rounded-lg mb-2 flex-row-reverse text-right
`;

const QuestionText = tw.span`text-right w-full text-2xl font-semibold`; // bigger like carousel captions

// const QuestionToggleIcon = motion(styled.span`
//   ${tw`ml-2 transition duration-300`}
//   svg {
//     ${tw`w-6 h-6`}
//   }
// `);
// const QuestionToggleIcon = motion(styled.span`
//   ${tw`mr-2 transition duration-300`}
//   svg {
//     ${tw`w-6 h-6`}
//   }
// `);

// const QuestionToggleIcon = motion(styled.span`
//   ${tw`ml-2 transition duration-300`}
//   svg {
//     ${tw`w-6 h-6`}
//   }
// `);
// const QuestionToggleIcon = motion(styled.span`
//   ${tw`transition duration-300`}
//   svg {
//     ${tw`w-6 h-6`}
//   }
// `);
const QuestionToggleIcon = motion(styled.span`
  ${tw`transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`);

// const Answer = motion(tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed`);
// const Answer = motion(tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed pr-4`);
const Answer = motion(tw.dd`
  pointer-events-none text-lg leading-relaxed pr-4 bg-white text-black rounded-lg p-4
`);

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-56 w-56 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
  subheading = "تعارف جامعہ | About Jamia",
  heading = "جامعہ محمدیہ عربیہ",
  description = "جامعہ محمد یہ عربیہ رائید رگ جنوبی ہند کی ایک عظیم الشان تعلیمی و تربیتی درس گاہ ہے، جو اپنی قدامت ، سلفیت ، اعلیٰ و معیاری تعلیم و تربیت اور حسن انتظام وانصرام میں مشہور و معروف ہے، یہاں صوبہ آندھرا پردیش، کرناٹک، مہاراشٹرا، اڑیسہ، گجرات، بہار، بنگال، اتر پردیش اور ملک نیپال جیسے دور دراز مقامات سے تشنگان علوم نبویہ تشریف لاتے ہیں اور اس سرچشمہ علم و عرفاں سے سیراب ہوتے ہیں ، اب تک یہاں سے سینکڑوں علماء و فضلاء، حفاظ وقراء اور دعاۃ ومبلغین فیضیاب ہو کر ملک و بیرون ملک مثالی خدمات انجام دے رہے ہیں .",
  faqs = [
    {
      question: "جامعہ محمدیہ عربیہ کی بنیاد کب رکھی گئی؟",
      answer: `
        جامعہ محمدیہ عربیہ کی بنیاد سید اسماعیل بن سید سرمست (رحمہ اللہ) نے 1926ء (1345ھ) میں جنوبی ہندوستان کے شہر رائیدرگ میں رکھی۔ ابتدائی طور پر اس کا نام انجمن محمدیہ تھا، جو بعد میں الجامعہ المحمدیہ العربیہ کے نام سے مشہور ہوا۔ اس ادارے کا مقصد قرآن و سنت کی تعلیمات پر مبنی معیاری اسلامی تعلیم فراہم کرنا تھا، جو بدعتوں، شرک اور خرافات سے پاک ہو۔
  
        سید اسماعیل رحمہ اللہ کو اپنے علاقے میں شرک، بدعات اور مختلف خرافات کے غلبے کا شدید احساس تھا، اور انہوں نے ایک ایسا تعلیمی ادارہ قائم کرنے کا عزم کیا جو اسلامی تعلیمات کی حقیقی بنیادوں پر کام کرے۔ ابتدائی طور پر جامعہ میں تعلیم مکتب کے طرز پر دی جاتی تھی، جہاں قرآن کی قراءت اور بنیادی اسلامی علوم سکھائے جاتے تھے۔
  
        1938ء میں سید اسماعیل رحمہ اللہ نے شہر کی مرکزی سڑک پر ایک عمارت خریدی، جہاں جامعہ کی تعلیمی سرگرمیاں مزید منظم طریقے سے جاری ہوئیں۔ اس وقت جامعہ میں صرف 100 طلباء تھے اور 3 اساتذہ تھے۔ تدریس کا زبان اردو تھی، اور ابتدائی تعلیم کے بعد طلباء کو دوسرے عربی مدارس میں تعلیم جاری رکھنے کی ترغیب دی جاتی تھی۔
  
        1941ء میں جامعہ نے آٹھ سالہ تعلیمی نظام شروع کیا، جس میں متوسطہ، ثانویہ، عالمیہ، اور فضیلت جیسے مراحل شامل تھے۔ اس تعلیمی نظام کا مقصد طلباء کو اسلامی علوم کی جامع تعلیم فراہم کرنا تھا، اور اس کے آخری مرحلے میں طلباء کو شہادت الفضیلت کی ڈگری دی جاتی تھی۔
  
        جامعہ محمدیہ عربیہ کی ترقی کا سلسلہ مسلسل جاری رہا اور 1952ء میں سید اسماعیل رحمہ اللہ نے رائیدرگ میں جامع مسجد تعمیر کرائی جو جامعہ کے قریب واقع ہے اور علاقے کی دیگر مساجد کے لیے بھی مرکز بن گئی۔ ان کی کاوشوں سے جامعہ کی اہمیت اور مقبولیت میں مزید اضافہ ہوا۔
  
        سید اسماعیل رحمہ اللہ نے اپنی زندگی میں سینکڑوں مدارس اور مساجد قائم کیں اور دینی تعلیمات کو فروغ دینے کے لیے متعدد علمی کانفرنسوں میں شرکت کی۔ انہوں نے اپنے کاموں کے ذریعے نہ صرف جنوبی ہندوستان میں بلکہ ہندوستان کے دیگر حصوں اور بیرون ملک بھی اسلام کی دعوت دی۔
  
        ان کی رہنمائی میں، جامعہ محمدیہ عربیہ نے دینی تعلیمات کو فروغ دیا اور آج بھی یہ ادارہ ایک عظیم تعلیمی مرکز کے طور پر اپنی خدمات جاری رکھے ہوئے ہے۔
      `,
    },
    {
      question: "جامعہ محمدیہ عربیہ کے بانی کون ہیں؟",
      answer:
        "جامعہ محمدیہ عربیہ کے بانی سید اسماعیل بن سید سرمست رحمہ اللہ ہیں۔ انہوں نے 1926ء میں شہر رائیدرگ میں انجمن محمدیہ کے نام سے اس ادارے کی بنیاد رکھی۔ اس کا مقصد قرآن و سنت کی تعلیمات کی بنیاد پر ایک تعلیمی ادارہ قائم کرنا تھا جو بدعتوں اور خرافات سے پاک ہو۔\n\nسید اسماعیل رحمہ اللہ نے اپنی ابتدائی تعلیم اپنے والد سے حاصل کی اور پھر مختلف علاقوں میں علم کی تکمیل کی۔ آپ نے اپنی زندگی میں اسلامی تعلیمات کی پھیلاؤ اور مدارس کے قیام میں نمایاں خدمات انجام دیں۔\n\nان کا ادارہ ابتدا میں 'مکتب' طرز پر تھا، اور بعد میں یہ 'الجامعہ المحمدیہ العربیہ' کے طور پر مشہور ہوا۔ آپ کی کاوشوں کے نتیجے میں جامعہ نے بہت جلد ترقی کی اور ملک بھر سے طلباء یہاں تعلیم حاصل کرنے کے لیے آنا شروع ہوگئے۔\n\nسید اسماعیل رحمہ اللہ کا انتقال 31 جنوری 1983ء کو ہوا، لیکن آپ کی خدمات اور تعلیمات آج بھی جامعہ محمدیہ عربیہ میں جاری ہیں۔",
    },
    {
      question: "جامعہ کی بنیاد کے پیچھے کیا تاریخ ہے؟",
      answer:
        "سید اسماعیل رحمہ اللہ نے جامعہ محمدیہ عربیہ کی بنیاد 1926 میں رکھی، تاکہ صحیح اسلامی علم کی ترویج کی جا سکے۔ اس وقت رائیدرگ اور دیگر علاقوں میں شرک و بدعات کا غلبہ تھا، اور آپ نے اس جامعہ کو اس مقصد کے تحت قائم کیا کہ لوگوں کو قرآن و سنت کی تعلیمات سے آگاہ کیا جائے اور غیر اسلامی عقائد سے بچایا جائے۔ آپ نے اس ادارے کے ذریعے لوگوں کو صحیح اسلام سکھانے کی کوشش کی اور اپنی زندگی کو اس مشن کے لیے وقف کر دیا۔",
    },

    {
      question: "جامعہ کی اہم کامیابیاں کیا ہیں؟",
      answer:
        "جامعہ محمدیہ عربیہ رائیدرگ نے اپنی تعلیم اور تربیت کے معیار سے بڑی کامیابیاں حاصل کی ہیں۔ یہاں سے سینکڑوں علماء و فضلاء، حفاظ وقراء، اور دعاۃ و مبلغین فارغ التحصیل ہو کر ملک و بیرون ملک میں اسلام کی دعوت دینے کی خدمات انجام دے رہے ہیں۔ اس جامعہ نے جنوبی ہندوستان میں اسلامی تعلیمات کی ترویج کی اور بے شمار دینی مدارس قائم کیے۔ جامعہ نے اپنے تعلیمی نظام کی توسیع کی اور آٹھ سالہ نصاب کے تحت تعلیم فراہم کی، جس میں متوسطہ، ثانویہ، عالمیہ، اور فضیلت کے مراحل شامل تھے۔ اس کے علاوہ، جامعہ نے اپنی بہترین کارکردگی کی بنا پر اپنے طلبہ کو معتبر تعلیمی اسناد فراہم کیں اور شہادت الفضیلت کی اسناد دینے کا آغاز کیا۔ جامعہ کی کتب خانہ المکتبہ المحمدیہ میں نایاب مخطوطات اور کتابیں جمع کی گئیں، اور کئی تعلیمی شاخوں کا قیام عمل میں آیا۔",
    },
  ],
}) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = (index) => {
    setActiveQuestionIndex(index === activeQuestionIndex ? null : index);
  };

  return (
    <PageWrapper>
      <Container>
        <ContentWithPaddingXl>
          <Column>
            <HeaderContent>
              <WordSpacedText>
                {subheading && <Subheading>{subheading}</Subheading>}
              </WordSpacedText>
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
            </HeaderContent>
            <FAQSContainer>
              {faqs.map((faq, index) => (
                <FAQ
                  key={index}
                  onClick={() => toggleQuestion(index)}
                  className="group"
                >
                  {/* <Question>
                  <QuestionText dir="rtl">{faq.question}</QuestionText>
                  <QuestionToggleIcon
                    variants={{
                      collapsed: { rotate: 0 },
                      open: { rotate: -180 }
                    }}
                    initial="collapsed"
                    animate={activeQuestionIndex === index ? "open" : "collapsed"}
                    transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
                  >
                    <ChevronDownIcon />
                  </QuestionToggleIcon>
                </Question> */}
                  {/* <Question>
  <QuestionText>{faq.question}</QuestionText>
  <QuestionToggleIcon
    initial={{ rotate: 0 }}
    animate={{ rotate: activeQuestionIndex === index ? -180 : 0 }}
    transition={{ duration: 0.3 }}
  >
    <ChevronDownIcon />
  </QuestionToggleIcon>
</Question> */}
                  <Question>
                    <QuestionText>{faq.question}</QuestionText>
                    <QuestionToggleIcon
                      initial={{ rotate: 0 }}
                      animate={{
                        rotate: activeQuestionIndex === index ? -180 : 0,
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <ChevronDownIcon />
                    </QuestionToggleIcon>
                  </Question>

                  <Answer
                    dir="rtl"
                    variants={{
                      open: { opacity: 1, height: "auto", marginTop: "16px" },
                      collapsed: { opacity: 0, height: 0, marginTop: "0px" },
                    }}
                    initial="collapsed"
                    animate={
                      activeQuestionIndex === index ? "open" : "collapsed"
                    }
                    transition={{
                      duration: 0.3,
                      ease: [0.04, 0.62, 0.23, 0.98],
                    }}
                  >
                    {faq.answer}
                  </Answer>
                </FAQ>
              ))}
            </FAQSContainer>
          </Column>
        </ContentWithPaddingXl>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </Container>
    </PageWrapper>
  );
};
